import React, { useContext } from 'react'
import UseLang from '../../../../hooks/UseLang' 
import { LangContext } from '../../../../context/DataContext'
import { reportData } from '../../../../data/report-data/report-data/reportData'

const TitleReport = () => {
    const {myLang} = useContext(LangContext)
    return (
        <h1>{reportData.investigacionAtaquesDdos[myLang].title}</h1>
    )
}

function InvestigacionAtaquesDdosResumen() {
    return (
        <> 
             <TitleReport />
            <div id="p1" className="alerts alert_white">
                
                <UseLang es> 
                    <p>Autor: Paula Venosa y Paul Bernal </p>
                    <p>Coordinaci&oacute;n y Revisi&oacute;n: &Aacute;rea de Comunicaciones</p>
                    <p>Edici&oacute;n: &Aacute;rea de Tecnolog&iacute;a</p>
                    <p>&Aacute;rea: &Aacute;rea de Tecnolog&iacute;a</p>
                    <p>Diciembre 2024</p> 
                </UseLang>
                <UseLang en>
                    <p>Author: Paula Venosa y Paul Bernal</p>
                    <p>Coordination and Revision: Graciela Mart&iacute;nez</p>
                    <p>Edition: Communications Area</p>
                    <p>Departament: Technology Area</p>
                    <p>December 2024</p> 
                </UseLang>
                <UseLang pt> 
                    <p>Autor: Paula Venosa y Paul Bernal</p>
                    <p>Coordenação e revisão: Graciela Mart&iacute;nez</p>
                    <p>Edição: &Aacute;rea de Comunicações</p>
                    <p>&Aacute;rea: &Aacute;rea de Tecnologia</p>
                    <p>Dezembro 2024</p> 
                </UseLang>
            </div>
        </>
    )
}

export default InvestigacionAtaquesDdosResumen